<h2 mat-dialog-title class="cancel-title">Oh no! We'll miss you!</h2>

<mat-dialog-content [formGroup]="cancelForm" class="cancel-content">
    <p class="cancel-message">
        Wait! Are you sure you want to cancel? We'd love to help you make the most of our features.
    </p>
    <p class="cancel-feedback">
        {{
            showRadioOptions
                ? "We'd love to know why you're leaving. Your feedback helps us improve!"
                : "If you don't mind sharing, we'd love to know why you're leaving. Your feedback helps us improve!"
        }}
    </p>
    <!-- Show radio group only when flag is true -->
    <ng-container *ngIf="showRadioOptions; else simpleTextarea">
        <mat-label class="cancel-radio-label">What’s the main reason you’re leaving?</mat-label>
        <mat-radio-group formControlName="selectedReason" class="cancel-radio-group small-radio-group">
            <mat-radio-button *ngFor="let reason of reasons" [value]="reason" class="small-radio-button">
                {{ reason }}
            </mat-radio-button>
        </mat-radio-group>

        <mat-form-field
            appearance="fill"
            class="cancel-textarea"
            *ngIf="cancelForm.get('selectedReason')?.value === CancelReasonEnum.Other">
            <mat-label>Reason for leaving</mat-label>
            <textarea matInput placeholder="Please write here the reason you leave..." formControlName="reason">
            </textarea>
        </mat-form-field>
    </ng-container>

    <!-- Fallback: show textarea directly -->
    <ng-template #simpleTextarea>
        <mat-form-field appearance="fill" class="cancel-textarea">
            <mat-label>Reason for leaving</mat-label>
            <textarea matInput placeholder="Please write here the reason you leave..." formControlName="reason">
            </textarea>
        </mat-form-field>
    </ng-template>
</mat-dialog-content>

<mat-dialog-actions align="center" class="cancel-actions">
    <button mat-raised-button color="primary" (click)="onKeepPlan()">Keep my plan</button>
    <button mat-raised-button color="warn" [disabled]="cancelForm.invalid" (click)="onCancelAnyway()">
        Cancel anyway
    </button>
</mat-dialog-actions>
